import createReducer from '../helpers/CreateReducer';
import { OrderHistoryConstants } from '../constants/actions';
import { OrderHistorySorting } from '../constants/orderHistorySorting';

interface QueryParameters {
  page: number;
  rowsPerPage: number;
  sortingBy: typeof OrderHistorySorting | string;
  descending: boolean;
}

interface OrderHistoryState {
  noPersistance: boolean;
  queryParameters: QueryParameters;
}

interface UpdateQueryParametersPayload {
  newQueryParameters: QueryParameters;
}

export const getInitialState = (): OrderHistoryState => ({
  noPersistance: true,
  queryParameters: {
    page: 1,
    rowsPerPage: 5,
    sortingBy: OrderHistorySorting.ByDate,
    descending: true
  }
});

export default createReducer(getInitialState, {
  [`${OrderHistoryConstants.RESET_VOUCHER_ORDERS_HISTORY_QUERY_PARAMETERS}`]: (
    state: OrderHistoryState
  ): OrderHistoryState => ({
    ...state,
    queryParameters: { ...getInitialState().queryParameters }
  }),

  [`${OrderHistoryConstants.UPDATE_VOUCHER_ORDERS_HISTORY_QUERY_PARAMETERS}`]: (
    state: OrderHistoryState,
    payload: UpdateQueryParametersPayload
  ): OrderHistoryState => ({
    ...state,
    queryParameters: payload.newQueryParameters
  })
});
